import React from "react";
import Image from "next/image";

const Partners = () => {
    return (
        <div className="flex flex-wrap items-center justify-center max-w-4xl mx-auto pt-4 pb-4">
            <div
                className="w-1/2 md:w-1/3 lg:w-1/5 px-8 mb-8 animate__animated animate__fadeIn"
                data-wow-delay=".1s"
            >
                <a href="https://www.cohesian.be/" target="_blank">
                    <Image
                        src="/assets/imgs/logos/brands/brand-6.png"
                        alt="Brand Cohesian"
                        className="mx-auto w-full h-full"
                        width="0"
                        height="0"
                        layout="responsive"
                        objectFit="contain"
                    /></a>
            </div>
            <div
                className="w-1/2 md:w-1/3 lg:w-1/5 px-8 mb-8 animate__animated animate__fadeIn"
                data-wow-delay=".2s"
            >
                <a href="https://vercel.com/" target="_blank">
                    <Image
                        src="/assets/imgs/logos/brands/brand-2.png"
                        alt="Brand Vercel"
                        className="mx-auto w-full h-full"
                        layout="responsive"
                        objectFit="contain"
                        width="0"
                        height="0"
                    /></a>
            </div>
            <div
                className="w-1/2 md:w-1/3 lg:w-1/5 px-8 mb-8 animate__animated animate__fadeIn"
                data-wow-delay=".3s"
            >
                <a href="https://entego.be/" target="_blank">
                    <Image
                        src="/assets/imgs/logos/brands/brand-3.png"
                        alt="Entego Logo"
                        className="mx-auto w-full h-full"
                        layout="responsive"
                        objectFit="contain"
                        width="0"
                        height="0"
                    />
                </a>
            </div>
            <div
                className="w-1/2 md:w-1/3 lg:w-1/5 px-8 mb-8 animate__animated animate__fadeIn"
                data-wow-delay=".5s"
            >
                <a href="https://www.minimaworks.be/" target="_blank">
                    <Image
                        src="/assets/imgs/logos/brands/brand-5.png"
                        alt="MINIMA SOLUTIONS"
                        className="mx-auto w-full h-full"
                        layout="responsive"
                        objectFit="contain"
                        width="0"
                        height="0"
                    />
                </a>
            </div>

        </div>
    );
};

export default Partners;
